import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="flex min-h-[70vh] flex-col items-center justify-center bg-background-50 px-4 text-center">
        <p className="font-heading text-8xl font-black text-primary-200 md:text-[10rem] select-none" aria-hidden="true">
          404
        </p>
        <h1 className="mt-2 font-heading text-2xl font-black text-foreground-900">页面走丢了</h1>
        <p className="mt-2 max-w-md text-sm leading-7 text-foreground-600">
          你访问的页面不存在或已被移动。可以返回首页，或去资讯中心看看最新爆料。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link to="/" className="inline-flex h-11 items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600">
            <i className="ri-home-5-line" aria-hidden="true" />
            返回首页
          </Link>
          <Link to="/news" className="inline-flex h-11 items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700">
            查看最新爆料
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}